export const RISK_CATEGORY_NAME_MAX_LENGTH = 100;

export const normalizeRiskCategoryName = (name) => String(name || "").trim();

export const getRiskCategoryNameError = (name, categories = [], options = {}) => {
  const normalized = normalizeRiskCategoryName(name);
  const excludeId = options?.excludeId ?? null;

  if (!normalized) {
    return "Category name is required.";
  }

  if (normalized.length > RISK_CATEGORY_NAME_MAX_LENGTH) {
    return `Category name must be ${RISK_CATEGORY_NAME_MAX_LENGTH} characters or fewer.`;
  }

  const hasDuplicate = (categories || []).some((category) => {
    if (!category?.name) return false;
    if (excludeId !== null && String(category.id) === String(excludeId)) return false;
    return normalizeRiskCategoryName(category.name).toLowerCase() === normalized.toLowerCase();
  });

  if (hasDuplicate) {
    return "Category name already exists.";
  }

  return "";
};

export const buildRiskCategoryPayload = ({
  name,
  description = "",
  status = "active",
}) => ({
  name: normalizeRiskCategoryName(name),
  description: String(description || "").trim() || null,
  status,
});
